import { ButtonWithLoading } from "@dexteel/mesf-core";
import { Button, ButtonGroup, Grid } from "@mui/material";
import { Pause, PlayArrow } from "@mui/icons-material";
import { useEffect } from "react";

type Props<T extends { ProcessId: number }> = {
  seconds: number;
  isRunning: boolean;
  pause: () => void;
  restart: () => void;
  resume: () => void;
  refreshData: () => Promise<void>;
  isDataLoading: boolean;
  process: T | undefined;
};

export const RefreshButtons = <T extends { ProcessId: number }>({
  seconds,
  isRunning,
  pause,
  restart,
  resume,
  refreshData,
  isDataLoading,
  process,
}: Props<T>) => {
  useEffect(() => {
    restart();
  }, [process?.ProcessId]);

  return (
    <Grid item container direction={"column"} style={{ width: "100%" }}>
      <Grid item style={{ width: "100%" }}>
        <ButtonGroup fullWidth>
          <ButtonWithLoading
            onClick={() => {
              pause();
              refreshData().then(() => {
                restart();
                resume();
              });
            }}
            fullWidth
            variant={"contained"}
            color={"primary"}
            isLoading={isDataLoading}
            style={{ fontSize: "0.9rem", height: 36, minHeight: 36 }}
          >
            Refresh in {seconds}
          </ButtonWithLoading>
          <Button
            size="medium"
            sx={{
              maxWidth: "40px",
            }}
            onClick={() => {
              isRunning ? pause() : resume();
            }}
          >
            {isRunning ? <Pause /> : <PlayArrow />}
          </Button>
        </ButtonGroup>
      </Grid>
    </Grid>
  );
};
